import {
  InitiativeStatus,
  normalizeKeyInitiativeStatus,
} from 'partner360/entities/keyInitiatives/model/status'

import styles from '../Status.module.scss'

export const getStatusColorByValue = (status: string) => {
  switch (normalizeKeyInitiativeStatus(status)) {
    case InitiativeStatus.AtRisk:
      return styles.needAttention
    case InitiativeStatus.OnTrack:
      return styles.workInProgress
    case InitiativeStatus.Done:
      return styles.done
    case InitiativeStatus.New:
      return styles.new
    default:
      return undefined
  }
}
